import { Directive, ElementRef, EventEmitter, Host, HostListener, OnDestroy, Output } from '@angular/core';
import { CodeInputComponent } from 'angular-code-input';
import { Subscription } from 'rxjs';

/** The widget schedules one delayed completion per keystroke. A fast entry can
 * therefore emit the same completed code repeatedly. Emit once per user edit. */
@Directive({selector: 'code-input[appDistinctCode]', standalone: true})
export class DistinctCodeDirective implements OnDestroy {
  @Output() distinctCodeCompleted = new EventEmitter<string>();
  private completed: string | null = null;
  private subscription: Subscription;
  private onPaste = () => this.edited();
  constructor(@Host() input: CodeInputComponent, private element: ElementRef<HTMLElement>) {
    // The library stops paste propagation; observe it in the capture phase.
    this.element.nativeElement.addEventListener('paste', this.onPaste, true);
    this.subscription = input.codeCompleted.subscribe(code => {
      if (code === this.completed) { return; }
      this.completed = code;
      this.distinctCodeCompleted.emit(code);
    });
  }
  // Resetting the widget is silent by default. The next actual input/paste must
  // allow the same code again, including after a rejected verification attempt.
  @HostListener('input')
  edited(): void { this.completed = null; }
  @HostListener('keydown', ['$event'])
  keydown(event: KeyboardEvent): void {
    if (event.key === 'Backspace' || event.key === 'Delete') { this.edited(); }
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.element.nativeElement.removeEventListener('paste', this.onPaste, true);
  }
}
